import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    row: {
        marginBottom: '1rem',
    },
    label: {
        color: 'grey',
        fontSize: '0.9rem',
        fontWeight: 400,
        marginBottom: '0.25rem',
    },
    field: {
        borderRadius: '2rem',
        fontSize: '1rem',
        paddingLeft: '0.6rem',
        paddingRight: '0.6rem',
        alignItems: 'center',
    },
    chipFieldGridItem: {
        [theme.breakpoints.down('xl')]: {
            flexGrow: 0,
            flexBasis: '100%',
        },
        [theme.breakpoints.up('xl')]: {
            flexGrow: 0,
            flexBasis: '25%',
        },
    },
    chipFieldRow: {
        marginBottom: '2rem',
    },
    chipFieldInput: {
        borderRadius: '2rem',
        paddingBottom: '7px',
    },
    descriptionField: {
        borderRadius: '1rem',
        paddingLeft: '1.6rem',
    },
    centeredField: {
        textAlign: 'center',
    },
    switch: {
        marginTop: '0.5rem',
    },
    formGridRow: {
        gap: '2rem',
        '& .MuiGrid-item': {
            [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
                width: '100%',
            },
            [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
                flexGrow: 1,
            },
        },
    },
    removeButtonGridItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    coinsRow: {
        marginBottom: '1rem',
    },
    errorText: {
        fontSize: '0.8rem',
        color: theme.palette.primary.main,
        marginLeft: '0.5rem',
        marginTop: '0.25rem',
    },
}));
